export const getJobTypes = () => {
  return [
    {
      value: 'delete',
      label: 'delete'
    }
  ]
}
